export const CLASSIFICATION_RATING_DEALER = 62
export const CLASSIFICATION_FIDELITY_MONTH = 66
export const CLASSIFICATION_FIDELITY_WEEK = 67
export const CLASSIFICATION_STORE_STATUS = 68

export const CLASSIFICATION_SQUARES = [
  CLASSIFICATION_RATING_DEALER,
  CLASSIFICATION_FIDELITY_MONTH,
  CLASSIFICATION_FIDELITY_WEEK,
  CLASSIFICATION_STORE_STATUS
]

export default {
  CLASSIFICATION_RATING_DEALER,
  CLASSIFICATION_FIDELITY_MONTH,
  CLASSIFICATION_FIDELITY_WEEK,
  CLASSIFICATION_STORE_STATUS,
  CLASSIFICATION_SQUARES
}
